module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "latest-stories-container"
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.processImg($event)
      }
    }
  }), _vm._v(" "), (_vm.initialOrder.length !== 0) ? _c('draggable', {
    staticClass: "latest-stories-draggable",
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      },
      "change": _vm.reorderItems
    },
    model: {
      value: (_vm.initialOrder),
      callback: function($$v) {
        _vm.initialOrder = $$v
      },
      expression: "initialOrder"
    }
  }, _vm._l((_vm.initialOrder), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "border flex-row"
    }, [_c('svg', {
      staticClass: "draggable-icon",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0V0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card flex-row"
    }, [_c('a', {
      staticClass: "post-link flex-column-ats",
      attrs: {
        "href": "#"
      }
    }, [(!item.image) ? _c('img', {
      staticClass: "object-fit lazyload-images loaded",
      attrs: {
        "src": item.tempImage
      }
    }) : _vm._e(), _vm._v(" "), (item.image) ? _c('div', {
      staticClass: "new-image-container"
    }, [_c('img', {
      staticClass: "upload-image",
      attrs: {
        "src": item.image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "new-image-details"
    }, [(item.image) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.deleteImage(item.image, key)
        }
      }
    }, [_vm._v("Remove Item")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('span', {
      staticClass: "card-category btn btn-pink"
    }, [_vm._v("tv")]), _vm._v(" "), (!_vm.showEditText || _vm.currentIndex !== key) ? _c('h3', {
      on: {
        "click": function($event) {
          _vm.selectTextInput(key)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), _c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.getText(key)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showEditText && _vm.currentIndex === key),
        expression: "showEditText && currentIndex === key"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.form.newTitle),
        expression: "form.newTitle"
      }, {
        name: "focus",
        rawName: "v-focus"
      }],
      ref: "titleInput",
      refInFor: true,
      staticClass: "title-input",
      attrs: {
        "type": "text",
        "placeholder": item.title,
        "required": ""
      },
      domProps: {
        "value": (_vm.form.newTitle)
      },
      on: {
        "blur": function($event) {
          _vm.showEditText = false
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "newTitle", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "post-author flex-row-ats flex-align-end flex-justify-center flex1"
    }, [_c('div', {
      staticClass: "author-meta flex-column flex-justify-space-between flex-align-center top-story-meta"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "card-menu"
    }, [_c('svg', {
      staticClass: "add-photo",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      },
      on: {
        "click": function($event) {
          _vm.selectImg(key)
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "remove-x",
      on: {
        "click": function($event) {
          _vm.removeItem(key)
        }
      }
    }, [_vm._v("×")])])])
  })) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e793ba7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/latestStoryPreview.vue
// module id = 652
// module chunks = 1